import { object } from 'prop-types';
import React, { useState } from 'react';
import formatDate from '../../../../../frontend/components/components/utils/formatDate';
import NoteEditor from '../../../../../frontend/components/components/utils/NoteEditor'

const BrandColumn = ({ userOffer }) => (
  <div key={userOffer.offer.brand_id}>
    {userOffer.offer.brand_name}
  </div>
);

const OfferColumn = ({ userOffer }) => (
  <a key={userOffer.offer_id} target="_blank" href={`/influencers/offer/${userOffer.offer.id}`}>
    {userOffer.offer.title}
  </a>
);

const CompletedDateColumn = ({ userOffer }) => (
  userOffer.completed_date ? formatDate(userOffer.completed_date) : ''
);

const StatusColumn = ({ userOffer }) => userOffer.status;

export const DEFAULT_COLUMNS = [
  'brand',
  'offer',
  'completed_date',
  'status'
];

export default {
  BrandColumn,
  OfferColumn,
  CompletedDateColumn,
  StatusColumn
};
